import {itemWithoutDiscounts} from './itemWithoutDiscounts';

export const query = `query getCategoryProductsWithoutDiscounts($compId: String!, $limit: Int!, $offset:Int = 0, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  catalog {
    category(compId: $compId) {
      id
      name
      productsWithMetaData(limit: $limit, offset: $offset, onlyVisible: true) {
        list {
          ${itemWithoutDiscounts}
        }
        totalCount
      }
    }
  }
}
`;
